var React = require('react');

function IconCheckmarkSm (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"currentColor","strokeWidth":"1","fill":"none","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("polyline",{"points":"0.5 5 2.5 7 8.5 2"})));
}

IconCheckmarkSm.defaultProps = {"viewBox":"0 0 9 9"};

module.exports = IconCheckmarkSm;

IconCheckmarkSm.default = IconCheckmarkSm;
